<template>
  <VCard v-if="isIOS" class="py-12 mt-3">
    <VRow justify="center">
      <VCol cols="12" class="d-flex flex-column justify-center align-center">
        <img src="../assets/img/interview/ios.svg" class="mb-2">
        <template>
          <div class="text-center title font-regular mb-2 px-3" style="max-width: 400px;">
            {{ $t('IOSSupport') }}
          </div>
          <ul style="list-style: none;">
            <li>
              1. {{ $t('IOSstepOne') }}
              <a :href="appStoreLink" target="_blank" style="font-weight: 600;">{{
                $t('IOSLink')
              }}</a>.
            </li>
            <li>
              2. {{ $t('IOSstepTwo') }}
            </li>
            <li>
              3. {{ $t('IOSstepThree') }}
            </li>
            <li>
              4. {{ $t('IOSstepFour') }}
            </li>
            <li>
              5. {{ $t('IOSstepFive') }}
            </li>
          </ul>
          <div class="app-ios-message__code-block">
            <span>{{ $t('IOSCode') }}:</span>
            <div class="app-ios-message__code-block_code">
              <div>
                <template v-if="candidate">
                  {{ domainPrefix }}:{{ candidate.hashId }}
                </template>
                <template v-else>
                  {{ domainPrefix }}:{{ vacancyId }}
                </template>
              </div>
              <div v-if="!linkCopied">
                <svg
                  style="width: 20px; margin-bottom: -5px;"
                  class="cursor-pointer ml-1"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  @click="copyLink()"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0" />
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M17.5 14H19C20.1046 14 21 13.1046 21 12V5C21 3.89543 20.1046 3 19 3H12C10.8954 3 10 3.89543 10 5V6.5M5 10H12C13.1046 10 14 10.8954 14 12V19C14 20.1046 13.1046 21 12 21H5C3.89543 21 3 20.1046 3 19V12C3 10.8954 3.89543 10 5 10Z"
                      stroke="#000000"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </svg>
              </div>
              <div v-else style="position:absolute; right: -22px; bottom: -22px">
                <svg
                  id="Layer_1"
                  style="margin-bottom: -6px;"
                  fill="rgb(31, 197, 127)"
                  height="23px"
                  width="23px"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 50 50"
                  enable-background="new 0 0 50 50"
                  xml:space="preserve"
                  stroke="rgb(31, 197, 127)"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0" />
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M40.267,14.628L20.974,33.921l-9.293-9.293c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l10,10 c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l20-20c0.391-0.391,0.391-1.023,0-1.414S40.657,14.237,40.267,14.628z "
                    />
                  </g>
                </svg>
                <span style="font-size: 12px;">{{ $t('codeWasCopied') }}</span>
              </div>
            </div>
          </div>
          <div class="text-center body-2 px-3 mt-5" style="max-width: 350px;">
            {{ $t('usePersonalComputer') }}
          </div>
        </template>
      </VCol>
    </VRow>
  </VCard>
</template>

<script>
import { isIOS } from '@/functions';
import copy from 'clipboard-copy';
import RecaptchaMixin from '../mixins/RecaptchaMixin';

export default {
  name: 'AppIosMessage',
  mixins: [RecaptchaMixin],
  props: {
    candidate: {
      type: Object,
      required: false,
      default: null,
    },
    vacancyId: {
      type: Number,
      required: true,
    },
    redirectUrl: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      appStoreLink: 'https://apps.apple.com/ru/app/huntica/id1514146235',
      testCandidate: null,
      linkCopied: false,
    };
  },
  computed: {
    inviteLink() {
      return this.redirectUrl || this.candidate?.inviteLink || this.testCandidate?.inviteLink || '#';
    },
    domainPrefix() {
      if (typeof window === 'undefined' || !window.location) {
        return 'ru';
      }
      const { hostname } = window.location;
      const hasWorks = hostname.includes('.works');
      const hasOnline = hostname.includes('.online');

      if (hasWorks) {
        return 'works';
      }
      if (hasOnline) {
        return 'online';
      }
      return 'ru';
    },
  },
  methods: {
    isIOS,
    copyLink() {
      if (this.candidate) {
        copy(`${this.domainPrefix}:${this.candidate.hashId}`);
      } else {
        copy(`${this.domainPrefix}:${this.vacancyId}`);
      }
      this.linkCopied = true;
    },
  },
};
</script>

<style scoped lang="scss">
.app-ios-message {
  &__code-block {
    display: flex;
    position: relative;
    margin-top: 16px;
    font-size: 20px;
    span {
      font-weight: 600;
    }
    @media screen and (max-width: 599px) {
      flex-direction: column;
      align-items: center;
    }
    &_code {
      display: flex;
      align-items: center;
      margin-left: 5px;
    }
  }
}
</style>

<i18n locale="en" lang="yaml">
IOSSupport: 'To pass an interview on an iOS device, you must:'
IOSSupportCode: 'To pass an interview on an iOS device, you must enter the invitation code in the application:'
IOSLink: AppStore
IOSCode: Your code
usePersonalComputer: You can also use a computer with a webcam or an Android device.
IOSstepOne: Download the app from
IOSstepTwo: Copy your code.
IOSstepTwoCode: Enter the invitation code in the application
IOSstepThree: Open the app.
IOSstepFour: Paste the code into the "Invitation Code" field.
IOSstepFive: Click "Go to".
IOSOnlineInterview: 'online interview.'
codeWasCopied: Code was copied
</i18n>

<i18n locale="ru" lang="yaml">
IOSSupport: 'Для прохождение собеседования на IOS устройстве необходимо:'
IOSSupportCode: 'Для прохождения собеседования на устройстве IOS, необходимо ввести код приглашения в приложении'
IOSLink: AppStore
IOSCode: Ваш код
usePersonalComputer: Так же вы можете использовать персональный компьютер или Android-устройство.
IOSstepOne: Скачать приложение с
IOSstepTwo: Скопируйте ваш код.
IOSstepTwoCode: Введите код приглашения в приложении
IOSstepThree: Откройте приложение.
IOSstepFour: Вставьте код в поле «Код приглашения».
IOSstepFive: Нажмите «Перейти».
IOSOnlineInterview: 'онлайн интервью.'
codeWasCopied: Код скопирован
</i18n>
